import * as v from 'valibot';

import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router';

import { faArrowsRepeat } from '@fortawesome/pro-duotone-svg-icons';

import { useNewRiskMutate } from '@repo/api/risk/risks';

import {
	Route as ClaimsHome,
	Filters as ClaimsHomeFilters,
} from '~pages/_claims/claims';
import { Route as NewRoute } from '~pages/_risks/risk.$riskId/(nopr)/create.$page';
import {
	Route as RisksHome,
	Filters as RisksHomeFilters,
} from '~pages/_risks/risks';
import { Page } from './-components/Page';
import { readHomeSearchSnapshot } from './-context/homeSearchStorage';

export const Route = createFileRoute('/_risks')({
	component: function Risks() {
		const { mutate: mutateNewRisk, isPending: newRiskLoading } =
			useNewRiskMutate();

		const navigate = useNavigate();
		const navigateToClaimsHome = () => {
			const search = readHomeSearchSnapshot('claims', (value) =>
				v.parse(ClaimsHomeFilters, value),
			);

			void navigate({
				to: ClaimsHome.to,
				...(search === undefined ? {} : { search }),
			});
		};
		const navigateToRisksHome = () => {
			const search = readHomeSearchSnapshot('risks', (value) =>
				v.parse(RisksHomeFilters, value),
			);

			void navigate({
				to: RisksHome.to,
				...(search === undefined ? {} : { search }),
			});
		};

		return (
			<Page
				home={{
					link: RisksHome,
					label: 'Risks',
					onNavigate: navigateToRisksHome,
				}}
				adminActions={[
					{
						name: 'Switch to Claims',
						icon: faArrowsRepeat,
						route: { to: ClaimsHome.to },
						permission: 'claim',
						onSelect: navigateToClaimsHome,
					},
				]}
				createButton={{
					permission: 'home.risk.create',
					label: 'Create New Risk',
					action: () => {
						mutateNewRisk(undefined, {
							onSuccess: (data) => {
								void navigate({
									to: NewRoute.to,
									params: { riskId: `${data.riskId}`, page: 'insured' },
								});
							},
						});
					},
					loading: newRiskLoading,
				}}
				help={[
					{
						label: 'Manual Intervention',
						name: 'ManualIntervention',
						message:
							'Need help? Watch this quick video guide to walk you through the manual intervention process',
					},
				]}
			>
				<Outlet />
			</Page>
		);
	},
});
